<template>
  <v-row class="pa-5" v-if="benefits">
    <v-col cols="12">
      <h2>Benefits Table</h2>
    </v-col>
    <v-col cols="11">
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th>
                Title
              </th>
              <th>
                Description
              </th>
              <th>
                Proof points
              </th>
              <th>
                Attributes
              </th>
              <th>
                Audience
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, count) in benefits"
              :key="`${item.title}-${count}`"
            >
              <td class="py-4">
                <h2>{{ item.title }}</h2>
              </td>
              <td class="py-4">
                {{ item.description }}
              </td>
              <td class="py-4">
                <ul
                  v-for="(sub, count) in item.items"
                  :key="`${index}-${count}`"
                >
                  <li>{{ sub }}</li>
                </ul>
                <!-- <v-chip
                  v-for="(sub, count) in item.items"
                  :key="`${index}-${count}`"
                  class="ma-1"
                  :class="item.color"
                >
                  {{ sub }}
                </v-chip> -->
              </td>
              <td class="py-4">
                <v-chip
                  v-for="(sub, count) in item.attributes"
                  :key="`${index}-${count}`"
                  class="ma-1"
                  :class="getColor(sub)"
                  small
                >
                  {{ sub }}
                </v-chip>
              </td>
              <td class="py-4">
                <v-chip
                  v-for="(sub, count) in item.audience"
                  :key="`${index}-${count}`"
                  class="ma-1"
                  :class="item.color"
                  small
                >
                  {{ sub }}
                </v-chip>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-col>
  </v-row>
</template>

<script>
// import lodash from "lodash";
const fb = require("@/firebaseConfig.js");
import { mapState } from "vuex";

export default {
  name: "ResultsBenefitsTable",
  data() {
    return {
      doc: null,
      attributes: [],
      benefits: [],
      dialog: false,
    };
  },
  props: {
    uid: String,
    id: String,
    model: String,
    lang: String,
  },

  mounted() {
    this.getAttributes();
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  methods: {
    getAttributes() {
      console.log("get attributes");
      let ref = fb.attributesPt1ExCollection.where("pid", "==", this.id);
      ref.onSnapshot((querySnapshot) => {
        let items = [];
        querySnapshot.forEach((docs) => {
          let post = docs.data();
          post.doc.attributes.forEach((benefit) => {
            items.push(benefit);
          });
        });
        this.attributes = items;
        this.getExercise();
      });
    },
    getExercise() {
      console.log("get exercise");
      let ref = fb.attributesPt2ExCollection.where("pid", "==", this.id);
      ref.onSnapshot((querySnapshot) => {
        let items = [];
        querySnapshot.forEach((docs) => {
          let post = docs.data();
          post.doc.benefits.forEach((benefit) => {
            items.push(benefit);
          });
          // this.getResults(post.doc);
        });
        this.benefits = items;
      });
    },
    getColor(title) {
      const item = this.attributes.find((x) => x.title === title);
      return item ? item.color : "";
    },
  },
};
</script>

<style lang="scss" scoped>
.v-data-table {
  overflow: visible !important;
  th,
  tr,
  td {
    vertical-align: top !important;
    padding: 10px !important;
    position: relative;
    &:first-child {
      width: 20%;
    }
    &:nth-child(2) {
      width: 20%;
    }
    &:nth-child(3) {
      width: 15%;
    }
  }
  th p {
    transform: rotate(-60deg) !important;
    text-align: left;
    transform-origin: left;
    position: absolute;
    left: 10px;
    bottom: 10px;
    width: 300px;
    z-index: 100;
    padding: 0px;
    margin: 0px;
    color: white;
  }
}
</style>
